import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../../meta';
import { getRatio } from '../../../helpers';
import { ItemData } from '../../items/ItemData';

export const SliderItem = ({ data, id, isDrag }) => {
  const settings = useSettings();
  const { sliderImageResize } = settings;
  const ratio = getRatio(settings);

  return (
    <Container $ratio={ratio}>
      <Content $resize={sliderImageResize}>
        <ItemData
          data={data}
          imageClassName={`${meta.stylePrefix}-slider-item-image`}
          id={id}
          isDrag={isDrag}
        />
      </Content>
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${meta.stylePrefix}-slider-item-component`
})`
  display: inline-flex;
  flex-direction: column;
  margin: 0 10px;
  overflow: hidden;
  align-items: center;
  position: relative;
  max-width: 960px;
  width: calc(100% - 20px);
  box-sizing: border-box;
  cursor: pointer;
  height: 0;

  padding-top: ${({ $ratio }) => $ratio * 100}%;
`;

const Content = styled.div.attrs({
  className: `${meta.stylePrefix}-slider-item-content`
})`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;

  & .${meta.stylePrefix}-slider-item-image {
    width: 100%;
    height: 100%;

    object-fit: ${({ $resize }) => ($resize === 'crop' ? 'cover' : 'contain')};
  }
`;
